import { useQuery, useQueryClient, useSuspenseQuery } from '@eika-infrastruktur/react-query';
import { getAccountProperties } from '../services/accountService';
const queryKey = ['get-account-properties'];
export function useAccountsPropertiesQuery() {
    return useQuery({
        queryKey,
        queryFn: getAccountProperties,
    });
}
export function useAccountsPropertiesSuspenseQuery() {
    return useSuspenseQuery({
        queryKey,
        queryFn: getAccountProperties,
    });
}
export const useRefreshAccountProperties = () => {
    const queryClient = useQueryClient();
    return () => {
        queryClient.invalidateQueries({ queryKey });
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQWNjb3VudHNQcm9wZXJ0aWVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2ZldGNoSG9va3MvdXNlQWNjb3VudHNQcm9wZXJ0aWVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxRQUFRLEVBQWUsY0FBYyxFQUFFLGdCQUFnQixFQUFFLE1BQU0saUNBQWlDLENBQUM7QUFHMUcsT0FBTyxFQUFFLG9CQUFvQixFQUFFLE1BQU0sNEJBQTRCLENBQUM7QUFFbEUsTUFBTSxRQUFRLEdBQUcsQ0FBQyx3QkFBd0IsQ0FBQyxDQUFDO0FBRTVDLE1BQU0sVUFBVSwwQkFBMEI7SUFDdEMsT0FBTyxRQUFRLENBQW9CO1FBQy9CLFFBQVE7UUFDUixPQUFPLEVBQUUsb0JBQW9CO0tBQ2hDLENBQUMsQ0FBQztBQUNQLENBQUM7QUFFRCxNQUFNLFVBQVUsa0NBQWtDO0lBQzlDLE9BQU8sZ0JBQWdCLENBQW9CO1FBQ3ZDLFFBQVE7UUFDUixPQUFPLEVBQUUsb0JBQW9CO0tBQ2hDLENBQUMsQ0FBQztBQUNQLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSwyQkFBMkIsR0FBRyxHQUFHLEVBQUU7SUFDNUMsTUFBTSxXQUFXLEdBQUcsY0FBYyxFQUFFLENBQUM7SUFFckMsT0FBTyxHQUFHLEVBQUU7UUFDUixXQUFXLENBQUMsaUJBQWlCLENBQUMsRUFBRSxRQUFRLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELENBQUMsQ0FBQztBQUNOLENBQUMsQ0FBQyJ9